import * as React from 'react';
import { cx } from '@/lib/ui';

export type AlertTone = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

const toneClasses: Record<AlertTone, string> = {
  info: 'border-sky-200 bg-sky-50 text-sky-900',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  warning: 'border-amber-200 bg-amber-50 text-amber-950',
  danger: 'border-rose-200 bg-rose-50 text-rose-900',
  neutral: 'border-slate-200 bg-slate-50 text-slate-800',
};

export function Alert({
  className,
  tone = 'neutral',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { tone?: AlertTone }) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cx('rounded-aula-md border px-4 py-3 text-sm leading-6', toneClasses[tone], className)}
      {...props}
    />
  );
}
